import styled from 'styled-components';

export const IngredientGenericContainer = styled.div`
  height: 40px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0 6px;

  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};
`;

export const IngredientInformations = styled.div`
  margin-left: 8px;
  overflow: hidden;

  & > p {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0;
  }

  & > p:first-child {
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
  }

  & > p:last-child:not(:first-child) {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const IngredientCardImage = styled.img`
  height: 40px;
  width: 32px;
  object-fit: cover;
  border-radius: 4px;
`;
